import "./RewardCard.css";
import coinIcon from "../../assets/icon/points.png";

const RewardCard = ({ data = {}, rupVal = 100 , isActive=false }) => {
  return (
    <>
      <div className="reward-section" style={{borderColor : isActive?"#179144" : "#342C59"}}>
        <div className="reward-img" style={{background : data?.outer_color}}>
          <img src={data?.image?.mobile} alt={data?.name} />
        </div>
        <div className="reward-info">
          <p className="reward-head">{data?.name}</p>
          <div className="reward-desc" dangerouslySetInnerHTML={{ __html: data.short_desc }}>
            {/* <p className="reward-desc">{data?.short_desc}</p> */}
            {/* <p className="reward-desc">Rs.300 weaver on any item</p> */}
          </div>
          <div className="reward-coin-info">
            <div className="reward-coin-img">
              <img src={coinIcon} alt="" width={18} height={18}/>
              <h4 className="reward-text1">{data?.price?.denominations[0] * rupVal}</h4>
            </div>
            <p className="reward-text2">Coins to redeem</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default RewardCard;
